export default {
  // Common
  common: {
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    reset: 'Сбросить',
    submit: 'Отправить',
    back: 'Назад',
    close: 'Закрыть',
    loading: 'Загрузка...',
    noData: 'Нет данных',
    operation: 'Операция',
    status: 'Статус',
    sort: 'Сортировка',
    createTime: 'Время создания',
    updateTime: 'Время обновления',
    actions: 'Действия',
    enable: 'Включить',
    disable: 'Отключить',
    active: 'Активный',
    inactive: 'Неактивный'
  },
  
  // Navigation
  nav: {
    dashboard: 'Панель управления',
    products: 'Продукты',
    productList: 'Список продуктов',
    categories: 'Категории',
    company: 'Информация о компании',
    cases: 'Клиентские кейсы',
    caseStudies: 'Исследования случаев',
    faq: 'Часто задаваемые вопросы',
    advantages: 'Основные преимущества',
    process: 'Процесс обслуживания',
    inquiries: 'Запросы',
    siteConfig: 'Конфигурация сайта',
    translations: 'Переводы'
  },
  
  // Login
  login: {
    title: 'Система управления CMS',
    username: 'Имя пользователя',
    password: 'Пароль',
    loginBtn: 'Войти',
    logout: 'Выйти',
    usernamePlaceholder: 'Введите имя пользователя',
    passwordPlaceholder: 'Введите пароль',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль?',
    tips: 'Советы',
    success: 'Вход выполнен успешно',
    error: 'Ошибка входа, проверьте имя пользователя и пароль'
  },
  
  // Dashboard
  dashboard: {
    title: 'Добро пожаловать в систему управления CMS',
    subtitle: 'Система управления контентом корпоративного сайта',
    totalProducts: 'Всего продуктов',
    totalCases: 'Всего кейсов',
    totalInquiries: 'Всего запросов',
    systemStatus: 'Состояние системы',
    quickAccess: 'Быстрый доступ',
    recentActivity: 'Последняя активность'
  },
  
  // Product
  product: {
    listTitle: 'Список продуктов',
    createTitle: 'Добавить продукт',
    editTitle: 'Редактировать продукт',
    productId: 'ID продукта',
    name: 'Название продукта',
    shortName: 'Краткое название',
    category: 'Категория',
    description: 'Описание',
    price: 'Цена',
    priceUnit: 'Единица цены',
    imageUrl: 'Основное изображение',
    badge: 'Значок',
    demoUrl: 'URL демо',
    features: 'Функции',
    highlights: 'Преимущества',
    techStack: 'Технологии',
    screenshots: 'Скриншоты',
    status: 'Статус',
    allCategories: 'Все категории',
    addFeature: 'Добавить функцию',
    addHighlight: 'Добавить преимущество',
    addTech: 'Добавить технологию',
    addScreenshot: 'Добавить скриншот',
    uploadImage: 'Загрузить изображение',
    selectCategory: 'Выбрать категорию'
  },
  
  // Category
  category: {
    categoryId: 'ID категории',
    name: 'Название категории',
    icon: 'Иконка',
    sortOrder: 'Порядок сортировки',
    status: 'Статус'
  },
  
  // Company
  company: {
    name: 'Название компании',
    englishName: 'Название на английском',
    slogan: 'Лозунг',
    description: 'Описание',
    founded: 'Основано',
    employees: 'Сотрудники',
    clients: 'Клиенты',
    projects: 'Проекты',
    phone: 'Телефон',
    email: 'Email',
    address: 'Адрес',
    workHours: 'Рабочее время',
    wechatLink: 'WeChat ссылка',
    weiboLink: 'Weibo ссылка',
    linkedinLink: 'LinkedIn ссылка'
  },
  
  // Client Case
  clientCase: {
    name: 'Название клиента',
    industry: 'Отрасль',
    systemType: 'Тип системы',
    logoIcon: 'Иконка логотипа',
    description: 'Описание',
    results: 'Результаты',
    sortOrder: 'Порядок сортировки',
    addResult: 'Добавить результат'
  },
  
  // Case Study
  caseStudy: {
    caseId: 'ID кейса',
    title: 'Заголовок',
    subtitle: 'Подзаголовок',
    clientName: 'Название клиента',
    industry: 'Отрасль',
    coverImage: 'Обложка',
    images: 'Изображения',
    challenge: 'Проблема',
    solution: 'Решение',
    results: 'Результаты',
    resultTags: 'Теги результатов',
    addImage: 'Добавить изображение',
    addTag: 'Добавить тег'
  },
  
  // FAQ
  faq: {
    question: 'Вопрос',
    answer: 'Ответ',
    sortOrder: 'Порядок сортировки',
    addQuestion: 'Добавить вопрос'
  },
  
  // Advantage
  advantage: {
    icon: 'Иконка',
    title: 'Заголовок',
    description: 'Описание',
    sortOrder: 'Порядок сортировки'
  },
  
  // Process
  process: {
    stepNumber: 'Номер шага',
    title: 'Заголовок',
    description: 'Описание',
    icon: 'Иконка'
  },
  
  // Site Config
  siteConfig: {
    siteName: 'Название сайта',
    siteTitle: 'Заголовок сайта',
    keywords: 'Ключевые слова',
    description: 'Описание',
    copyright: 'Авторское право',
    icpLicense: 'Лицензия ICP',
    publicSecurityLicense: 'Лицензия безопасности',
    seoConfig: 'SEO конфигурация',
    basicConfig: 'Базовая конфигурация',
    contactConfig: 'Контактная конфигурация',
    socialLinks: 'Социальные ссылки'
  },
  
  // Inquiry
  inquiry: {
    name: 'Имя',
    phone: 'Телефон',
    email: 'Email',
    company: 'Компания',
    content: 'Содержание',
    status: 'Статус',
    handleStatus: 'Статус обработки',
    handled: 'Обработано',
    unhandled: 'Не обработано',
    contactTime: 'Время контакта',
    remark: 'Примечание'
  },
  
  // Messages
  message: {
    confirmDelete: 'Вы уверены, что хотите удалить?',
    deleteSuccess: 'Успешно удалено',
    saveSuccess: 'Успешно сохранено',
    updateSuccess: 'Успешно обновлено',
    createSuccess: 'Успешно создано',
    operationFailed: 'Ошибка операции',
    dataNotExist: 'Данные не существуют',
    pleaseSelect: 'Пожалуйста выберите',
    inputRequired: 'Пожалуйста введите',
    uploadSuccess: 'Успешно загружено',
    uploadFailed: 'Ошибка загрузки',
    fileSizeLimit: 'Размер файла не может превышать',
    fileTypeLimit: 'Поддерживаются только форматы изображений',
    networkError: 'Ошибка сети, попробуйте позже'
  },
  
  // Validation
  validation: {
    required: '{field} обязательно для заполнения',
    minLength: '{field} должно быть не менее {min} символов',
    maxLength: '{field} не может превышать {max} символов',
    email: 'Введите корректный email адрес',
    phone: 'Введите корректный номер телефона',
    url: 'Введите корректный URL',
    number: 'Введите число',
    pattern: 'Неверный формат'
  },
  
  // Language
  language: {
    switcher: 'Язык',
    zhCN: '简体中文',
    zhTW: '繁體中文',
    en: 'English',
    ru: 'Русский'
  }
}
